<div class="dashboard-usage-widget">
  @if (loadError() && !overview()) {
  <div class="dashboard-usage-widget__state dashboard-usage-widget__state--error" role="alert">
    <mat-icon aria-hidden="true">error_outline</mat-icon>
    <p>{{ 'dashboard.usage_widget.loadError' | translate }}</p>
    <button
      type="button"
      mat-stroked-button
      color="primary"
      class="dashboard-usage-widget__retry"
      [disabled]="refreshing()"
      (click)="onRefreshClick($event)">
      {{ 'dashboard.usage_widget.retry' | translate }}
    </button>
  </div>
  } @else if (!vm()) {
  <div class="dashboard-usage-widget__state" aria-live="polite">
    <mat-progress-spinner diameter="28" mode="indeterminate"></mat-progress-spinner>
    <span>{{ 'dashboard.usage_widget.loading' | translate }}</span>
  </div>
  } @else {
  <div class="dashboard-usage-widget__content dashboard-lost-claim-card">
    <div class="dashboard-usage-widget__header">
      <div class="dashboard-usage-widget__title-row">
        <mat-card-title class="dashboard-card-title">
          {{ 'dashboard.usage_widget.title' | translate }}
        </mat-card-title>
        <button
          type="button"
          mat-icon-button
          class="dashboard-usage-widget__refresh"
          [disabled]="refreshing()"
          [attr.aria-label]="'dashboard.usage_widget.refresh' | translate"
          (click)="onRefreshClick($event)">
          @if (refreshing()) {
          <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
          } @else {
          <mat-icon>refresh</mat-icon>
          }
        </button>
      </div>
      <span class="dashboard-usage-widget__tier-pill">
        {{
          'dashboard.usage_widget.currentTier'
            | translate: tParams({ tier: vm()!.currentTier })
        }}
      </span>
    </div>

    <section class="dashboard-usage-widget__usage-panel">
      <div class="dashboard-usage-widget__usage-metrics">
        <div class="dashboard-usage-widget__usage-main">
          <strong class="dashboard-usage-widget__usage-number">{{ vm()!.claimCount }}</strong>
          <span class="dashboard-usage-widget__usage-label">
            {{ 'billingStatusWidget.usage.potentialCasesUsed' | translate }}
          </span>
        </div>
        <div class="dashboard-usage-widget__usage-next-tier">
          <strong>{{ vm()!.nextTierThreshold }}</strong>
          <span>{{ 'billingStatusWidget.usage.toNextTierLabel' | translate }}</span>
        </div>
      </div>

      <div class="dashboard-usage-widget__progress-section">
        <div
          class="dashboard-usage-widget__progress-track"
          role="progressbar"
          [attr.aria-valuenow]="vm()!.progressPercent"
          aria-valuemin="0"
          aria-valuemax="100">
          @if (vm()!.claimCount > 0) {
          <div
            class="dashboard-usage-widget__progress-fill"
            [style.width.%]="vm()!.progressPercent">
            @for (slice of vm()!.progressSlices; track slice.claimTypeValue) {
            <span
              class="dashboard-usage-widget__progress-segment"
              [style.flex]="'0 0 ' + slice.percentage + '%'"
              [style.background-color]="slice.color"
              [attr.title]="
                ('claimsTypes.' + slice.claimTypeValue | translate) +
                ': ' +
                (slice.percentage | number: '1.0-1') +
                '% (' +
                slice.count +
                ')'
              "
              [attr.aria-label]="
                ('claimsTypes.' + slice.claimTypeValue | translate) +
                ': ' +
                (slice.percentage | number: '1.0-1') +
                '%'
              ">
            </span>
            }
            <span class="dashboard-usage-widget__progress-milestone" aria-hidden="true"></span>
          </div>
          }
        </div>
        <div class="dashboard-usage-widget__progress-meta">
          <span
            class="dashboard-usage-widget__progress-marker"
            [class.dashboard-usage-widget__progress-marker--start]="vm()!.progressMarkerAnchor === 'start'"
            [class.dashboard-usage-widget__progress-marker--middle-end]="vm()!.progressMarkerAnchor === 'middle-end'"
            [class.dashboard-usage-widget__progress-marker--end]="vm()!.progressMarkerAnchor === 'end'"
            [style.left.%]="
              vm()!.progressMarkerAnchor === 'middle' ||
              vm()!.progressMarkerAnchor === 'middle-end'
                ? vm()!.progressPercent
                : null
            ">
            {{
              'billingStatusWidget.usage.tierMarker'
                | translate: tParams({
                    tier: vm()!.currentTier,
                    threshold: vm()!.nextTierThreshold
                  })
            }}
          </span>
        </div>
      </div>
    </section>

    <div
      class="dashboard-usage-widget__breakdown-slot"
      [class.dashboard-usage-widget__breakdown-slot--empty]="!vm()!.topSlices.length"
      [attr.aria-label]="'dashboard.usage_widget.breakdownLabel' | translate">
      @if (vm()!.topSlices.length) {
      <ul class="dashboard-usage-widget__breakdown">
        @for (slice of vm()!.topSlices; track slice.claimTypeValue) {
        <li>
          <span
            class="dashboard-usage-widget__breakdown-dot"
            [style.background]="slice.color"></span>
          <span class="dashboard-usage-widget__breakdown-label">
            {{ 'claimsTypes.' + slice.claimTypeValue | translate }}
          </span>
          <strong>{{ slice.count }}</strong>
        </li>
        }
      </ul>
      } @else {
      <div class="dashboard-usage-widget__breakdown-info" role="status">
        <mat-icon aria-hidden="true">info</mat-icon>
        <span>{{ 'dashboard.usage_widget.noBreakdown' | translate }}</span>
      </div>
      }
    </div>

    <button
      type="button"
      mat-stroked-button
      color="primary"
      class="dashboard-lost-claim-card__action"
      (click)="onViewDetailsClick()">
      {{ 'dashboard.usage_widget.viewDetails' | translate }}
    </button>
  </div>
  }
</div>
